import React from 'react'

import { getColorFromText } from '../../utils/colors'
import type { LogoImageProps } from './types'
import * as S from './styled'

export const LogoImage = ({
  logo,
  logoBackground,
  placeholder,
  placeholderVariant = 'mono',
  size = 'large',
  aspectRatio = 1.375,
}: LogoImageProps) => {
  const placeholderBackground =
    placeholderVariant === 'color' && typeof placeholder === 'string'
      ? getColorFromText(placeholder)
      : undefined

  return (
    <S.Container
      size={size}
      aspectRatio={aspectRatio}
      style={{ background: logo ? `url(${logoBackground}` : undefined }}
    >
      {logo ? (
        <S.Image src={logo} />
      ) : (
        <S.ImagePlaceholder
          size={size}
          style={{
            background: placeholderBackground,
            color: placeholderBackground ? '#fff' : undefined,
          }}
        >
          {placeholder}
        </S.ImagePlaceholder>
      )}
    </S.Container>
  )
}
